<template>
    <div>
        <div class="simple__block">
            <div class="order__block_info">
                <p>
                    <label>{{ formatText(get_translation_constant('text_tracking_number_full')) }}:</label> <a
                    href="javascript:void(0)" class="order__traking_number">{{ parcel.track_code }}</a><span
                    class="copy__traking_number"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"><path
                    d="M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z"
                    fill="#06C"/></svg>
                                        <span class="copy__traking_alert">{{
                                                get_translation_constant('text_copied_to_clipboard')
                                            }}</span></span>
                </p>
                <p><label>{{ formatText(getDateText) }}:</label> <span>{{ getParcelDate }}</span>
                </p>
                <p v-if="(typeof parcel.market_link !=='undefined')">
                    <label>{{ formatText(get_translation_constant('text_shop')) }}:</label>
                    <a class="order__shop_link" :href="parcel.market_link">{{ parcel.market.title }}</a>
                </p>
                <div class="order__print">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.11 17.76h.74v.82c0 .99.46 1.42 1.36 1.42h7.58c.9 0 1.36-.43 1.36-1.42v-.82h.75c1.37 0 2.1-.72 2.1-2.17V8.65c0-1.43-.73-2.17-2.1-2.17h-.7V6.1c0-1.45-.7-2.09-2-2.09H8.8c-1.23 0-2 .64-2 2.09v.4h-.69C4.8 6.48 4 7.21 4 8.64v6.94c0 1.45.73 2.17 2.11 2.17zm1.8-11.75c0-.62.3-.93.89-.93h6.4c.6 0 .9.3.9.93v.47H7.9v-.47zM6.1 16.65c-.63 0-.96-.35-.96-1V8.59c0-.65.33-1 .96-1H17.9c.62 0 .95.35.95 1v7.06c0 .65-.33 1-.95 1h-.76V12.2c0-.98-.46-1.41-1.36-1.41H8.21c-.85 0-1.36.43-1.36 1.41v4.45H6.1zm2.46 2.24c-.37 0-.57-.2-.57-.6v-5.8c0-.4.2-.58.57-.58h6.89c.38 0 .56.18.56.58v5.8c0 .4-.18.6-.56.6H8.56zm.99-4.31h4.92c.25 0 .44-.2.44-.47a.43.43 0 00-.44-.45H9.55c-.26 0-.45.2-.45.45 0 .27.2.47.45.47zm0 2.58h4.92c.25 0 .44-.2.44-.45 0-.26-.19-.46-.44-.46H9.55c-.26 0-.45.2-.45.46 0 .25.2.45.45.45z"
                            fill="#515154"/>
                    </svg>
                </div>
            </div>
            <div class="order__block_list" v-if="(typeof  parcel.products !== 'undefined') && parcel.products.length">
                <h3 class="h_text">{{ get_translation_constant('text_product_list') }}</h3>

                <table class="table table__order_item">
                    <thead>
                    <tr>
                        <th>{{ get_translation_constant('text_nomenclature') }}</th>
                        <th>{{ get_translation_constant('text_additional_services') }}</th>
                        <th>{{ get_translation_constant('text_quantity') }}</th>
                        <th>{{ get_translation_constant('text_price') }}</th>
                        <th>{{ get_translation_constant('text_total') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(product, key) in parcel.products">
                        <td><a href="#">{{ product.name }}</a></td>
                        <td>
                            <div
                                class="table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center">

                            <span v-for="(service, service_index) in parcel.services"
                                  class="tooltip__block tooltip__top tooltip__block_simple">
                              <span class="tooltip__block_trigger">
                                                        <img :src="service.icon" alt="" class="service-image">
                                                    </span>
                              <span class="tooltip__block_inner">
                                                        <p>{{ service.title }}</p>
                                                    </span>
                            </span>
                            </div>
                        </td>
                        <td><strong>{{ product.qty }} х</strong></td>
                        <td><strong>{{ product.price }} $</strong></td>
                        <td><strong>{{ (product.price * product.qty).toFixed(2) }} $</strong></td>
                    </tr>

                    </tbody>
                </table>


                <div class="row mb-4">
                    <div class="col-12 col-md-6">
<!--                        <div class="d-flex align-items-center agent__info">
                            {{ get_translation_constant('text_delivery_through_agent') }}
                            <span class="tooltip__block tooltip__bottom tooltip__modal">
                                        <span class="tooltip__block_trigger">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                                    fill="#515154"/>
                                            </svg>
                                        </span>
                                        <span class="tooltip__block_overlay">
                                                            <span class="tooltip__block_inner">
                                                                <span class="tooltip__block_close"></span>
                                                                <p>{{
                                                                        get_translation_constant('text_creating_agents_is_relevant')
                                                                    }}</p>
                                            <p><a href="#">{{
                                                    get_translation_constant('text_learn_more_about_agents')
                                                }}</a></p>
                                        </span>
                                        </span>
                                    </span>
                        </div>-->
                    </div>
                    <div class="col-12 col-md-6 text-md-end">
                        <div class="packages__total_price">
                            {{ get_translation_constant('text_total_products_price') }}:
                            <span>{{ totalProductPrice }}</span> $
                        </div>
                    </div>
                </div>

                <div class="d-md-flex justify-content-end" v-if="(parcel.parent_id ===null) && parcel.declared && (parcel.parcel_tracking_status_id < 3)">
                    <a class="btn btn__large btn__blue_link d-block"
                       :href="parcel.edit_parcel_link">{{ get_translation_constant('text_edit') }}</a>
                </div>

            </div>
            <div class="order__block_list" v-else>
                <div class="d-md-flex justify-content-end" v-if="(parcel.parent_id ===null) && parcel.declared">
                    <a class="btn btn__large btn__blue_link d-block"
                       :href="parcel.edit_parcel_link">{{ get_translation_constant('text_edit') }}</a>
                </div>

            </div>
            <!-- -->
        </div>
        <div class="alert__block" v-show="alert_files !== ''">
            <div class="alert__block_header">
                <h3 class="h_text">{{ get_translation_constant('text_files_not_accepted') }}</h3>
                <div class="alert__block_close" @click.p.prevent="clearAlertFiles">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z"
                            fill="#000"/>
                    </svg>
                </div>
            </div>
            <p v-for="(file, key) in alert_files">{{ file }}</p>
        </div>
        <file-upload
            v-on:childToParentAlert="setAlertData($event, 'alert_files')"
            :files_array="files"
            :multiple="true"
            :translations="translations"
            :ajax="true"
            :lng="lng"
            :upload_files_link="upload_files_link"
            :delete_files_link="delete_files_link"
            :additional_ajax_params="{ parcel_id: parcel.id }"
            :downloadlink="downloadlink"
        ></file-upload>
        <div class="simple__block mt-4" v-if="parcel.pictures.length">
            <file-upload
                :files_array="serverPictures"
                :multiple="true"
                :translations="translations"
                :ajax="false"
                :lng="lng"
                :upload_files_link="upload_files_link"
                :delete_files_link="delete_files_link"
                :additional_ajax_params="{ parcel_id: parcel.id }"
                :downloadlink="downloadlink"
                :template="'preview-photo'"
                ref="fileUpload"
            ></file-upload>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewToOnWarehouseOrder",
    props: {
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        parcel: {
            type: [Object],
            default: null
        },
        ordertype: {
            required: true,
            type: [String]
        },
        neworderslink: {
            type: [String]
        },
        ordersonwarehoselink: {
            type: [String]
        },
        sentorderslink: {
            type: [String]
        },
        arrivedorderslink: {
            type: [String]
        },
        deliveredorderslink: {
            type: [String]
        },
        upload_files_link: {
            type: [String]
        },
        delete_files_link: {
            type: [String]
        },
        downloadlink: {
            type: [String]
        },
    },
    data() {
        return {
            alert_files: '',
            files: [],
            serverPictures :[],
        }
    },
    methods: {
        setAlertData(e, field_name) {
            this.alert_files = e;
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        getOrderFlight(order) {
            return order?.flight?.title;
        },
        formatText(text){

            if (typeof  (text === 'undefined') || (text === '') || (text == null) ){
                return ''
            }

            let tmp = text.toLowerCase();
            return tmp.charAt(0).toUpperCase() + tmp.slice(1);
        }
    },
    computed: {
        getDateText() {
            if (this.ordertype === 'on-warehouse') {
                return this.get_translation_constant('text_sent_date');
            }
            return this.get_translation_constant('text_date');
        },
        getParcelDate() {
            if (this.ordertype === 'on-warehouse') {
                return this.parcel.sent_date;
            }
            return this.parcel.date

        },
        totalServicesSum() {
            let price = 0;
            let percentCoefficient = 0;
            let extraServiceSum = 0;
            this.parcel.services.map((item) => {
                if (!!item.as_a_percentage) {
                    percentCoefficient += item.value;
                } else {
                    extraServiceSum += item.value;
                }
            })
            price = this.parcel.weight_price * (1 + percentCoefficient / 100) + extraServiceSum;
            return price.toFixed(2) + '$';
        },
        getServicesPrices() {
            let html = '';
            this.parcel.services.map((service) => {
                html += '<span>' + service.title + '</span>';
                if (!!service.as_a_percentage) {
                    html += (this.parcel.weight_price * (1 + service.value / 100)
                    ).toFixed(2);
                } else {
                    html += service.value.toFixed(2);
                }
                html += '$' + '<br>';
            });
            return html;
        },
        totalProductPrice() {
            let price = 0;
            if (typeof this.parcel.products !== 'undefined') {
                this.parcel.products.map((product) => {
                    price += product.qty * product.price;
                });
            }
            return price.toFixed(2);
        }
    },
    created() {
        this.files = this.parcel.files;
        this.serverPictures = this.parcel.pictures;
    }
}
</script>

<style scoped>

</style>
